import {CCList} from './components/customer/cclist';
import {PayInvoice} from './components/Invoice/payInvoice';
import {PaymentReceipt} from './components/Invoice/paymentreceipt';
import './App.css';
import {OrderPaymentDetails} from './components/order/orderprepaymentdetails';
import {PrePaymentReceipt} from './components/order/prepaymentreceipt';
import { HashRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  const currentUrl = window.location.href;
  const isPayInvoicePage = currentUrl.includes('payinvoice');
  const isReceiptPage = currentUrl.includes('paymentreceipt');
   return (
    <Router>
    <div className="App">
    <Routes>
      <Route path="/invoices/v1.0/invoice/:invoiceId/payinvoice/:paymentId" element={<PayInvoice />} />
      <Route path="/invoices/v1.0/invoice/:invoiceId/payinvoice/:paymentId/paymentreceipt/:transactionId" element={<PaymentReceipt />} />
      <Route path="/customers/v1.0/customer/:customerId/requestpaymentdetails/:paymentId" element={<CCList />} />
      <Route path="/orders/v1.0/order/:orderId/payorder/:paymentId" element={<OrderPaymentDetails />} />
      <Route path="/orders/v1.0/order/:orderId/payorder/:paymentId/paymentreceipt/:transactionId" element={<PrePaymentReceipt />} />
      
    </Routes>
    </div>
  </Router>
   );
}

export default App;
